function appendNewLocale(contents, updatedLocales) {
  contents.forEach((content) => {
    updatedLocales.forEach((locale) => {
      if (
        !content.labelLocales.some(
          (labelLocale) => labelLocale.language == locale
        )
      ) {
        content.labelLocales.push({ language: locale, value: "" });
      }
    });
  });
}

function remapLocale(locale) {
  return {
    language: locale.language || "",
    value: locale.value || "",
  };
}

function remapValue(value) {
  if (!value) {
    return {
      rating: null,
      text: null,
      boolean: null,
    };
  }
  return {
    rating: value.rating || null,
    text: value.text || null,
    boolean: value.boolean === false ? false : !!value.boolean || null,
  };
}

function remapContent(content) {
  const labelLocales = (content.labelLocales &&
    content.labelLocales.map((l) => remapLocale(l))) || [
    remapLocale(content.labelLocale),
  ];
  return {
    fieldType: content.fieldType || "",
    labelLocales,
    value: remapValue(content.value),
  };
}
function remap(mf) {
  return {
    id: mf.id || null,
    code: mf.code || "",
    stage: mf.stage || 1,
    mentorSubmitFirst: mf.mentorSubmitFirst || false,
    menteeSubmitFirst: mf.menteeSubmitFirst || false,
    revision: mf.revision || "",
    revisionCreated: mf.revisionCreated || new Date(),
    form: {
      nameLocales:
        mf.form.nameLocales.map((nl) => ({
          language: nl.language,
          value: nl.value,
        })) || [],
      mentorContents: mf.form.mentorContents.map((c) => remapContent(c)) || [],
      menteeContents: mf.form.menteeContents.map((c) => remapContent(c)) || [],
    },
  };
}

export { appendNewLocale, remap, remapContent };
